import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ModalService {

    // Observable string sources
    private statusSource = new Subject<any>();
    private eventosSource = new Subject<any>();

    // Observable string streams
    status$ = this.statusSource.asObservable();
    eventos$ = this.eventosSource.asObservable();
    
    // Service message commands
    alterarStatus(status: any) {
        this.statusSource.next(status);
    }

    emitirEvento(evento: any) {
        this.eventosSource.next(evento);
    }

}


// WEBPACK FOOTER //
// ./src/app/utils/modal/modal.service.ts